import styles from "./ExpandableTable.module.scss";

const ExpandableTable = ({ title, subtitle, columns = [], data = [], rowKey = "id", fullWidth = false }) => {
	return (
		<div className={styles.container}>
			{!fullWidth && (title || subtitle) && (
				<div className={styles.header}>
					{title && <h4 className={styles.title}>{title}</h4>}
					{subtitle && <span className={styles.subtitle}>{subtitle}</span>}
				</div>
			)}

			<div className={styles.tableWrapper}>
				<table className={styles.table}>
					<thead className={styles.thead}>
						<tr>
							{columns.map((col) => {
								return (
									<th
										key={col.key}
										className={`${styles.th} ${col.align === "right" ? styles.alignRight : ""} ${
											col.align === "center" ? styles.alignCenter : ""
										}`}
									>
										{col.label}
									</th>
								);
							})}
						</tr>
					</thead>
					<tbody className={styles.tbody}>
						{data.map((row, rowIndex) => (
							<tr key={row[rowKey] || rowIndex} className={styles.tr}>
								{columns.map((col, colIndex) => (
									<td
										key={`${row[rowKey] || rowIndex}-${col.key || colIndex}`}
										className={`${styles.td} ${col.align === "right" ? styles.alignRight : ""}`}
									>
										{col.render ? col.render(row[col.key], row) : row[col.key]}
									</td>
								))}
							</tr>
						))}
						{data.length === 0 && (
							<tr>
								<td colSpan={columns.length} className={styles.empty}>
									No hay datos disponibles
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default ExpandableTable;
